"use client";

import reactHtmlParser, { attributesToProps, domToReact } from "html-react-parser";

import {
  Accordion,
  AccordionToggle,
  AccordionCollapse,
} from "@stadium/ui/src/components/accordion/bootstrap-accordion/styled";
import { ExternalButton } from "@sharedComponents/buttons";

const emptyObj = {};

import styles from "./main.module.scss";

const getReactParserOptions = () => ({
  replace(domNode) {
    if (domNode.attribs && domNode.name === "collapsible") {
      const props = attributesToProps(domNode.attribs);
      return (
        <Accordion
          key={props?.id as string}
          eventKey={props?.id as string}
          className={styles.faqRow}
        >
          <AccordionToggle eventKey={props?.id as string} className={styles.faqTitle}>
            {props?.header}
          </AccordionToggle>
          <AccordionCollapse eventKey={props?.id as string} className={styles.faqContent}>
            <>{domToReact(domNode.children)}</>
          </AccordionCollapse>
        </Accordion>
      );
    }
  },
});

const FaqWidget = ({ data }) => {
  const { jsonContent } = data ?? emptyObj;
  const {
    rte_content = "",
    title = "",
    subtitle = "",
    background_color = "#ffffff",
    button_text = "See More",
    button_link = "",
  } = JSON.parse(jsonContent) ?? emptyObj;

  if (rte_content) {
    return (
      <div className={styles.faqSection} style={{ backgroundColor: background_color }}>
        <div className={styles.faqSubtitle}>{subtitle}</div>
        <div className={styles.faqSliceTitle}>{title}</div>
        {reactHtmlParser(rte_content, getReactParserOptions())}
        {button_link && (
          <div className={styles.faqButton}>
            <ExternalButton href={button_link} showExternalLinkIcon>
              <span className={styles.faqButtonText}>{button_text}</span>
            </ExternalButton>
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default FaqWidget;
